import { getEvents } from '../../../browser/services/events';
import { EAuthenticationActionTypes, TModalClose } from './types';

export const modalClose = (isAuthenticated?: boolean): TModalClose => {
  if (!isAuthenticated) {
    getEvents().authModalClosedNoAuth();
  }

  return {
    type: EAuthenticationActionTypes.ModalClose,
    payload: undefined,
  };
};
